import { CHURN_ZERO_EVENTS } from '../../../../utils/constants.tsx'
import { useEffect, useState } from 'react'
import { getImageUrl } from 'services/assets'
import { trackEvent } from 'utils/tracking'
import { setSnackBar } from 'state/ui'
import { useAppDispatch } from 'utils/custom-hooks/useTypedReduxStore.ts'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import 'yet-another-react-lightbox/plugins/thumbnails.css'

const AssetImagesLightbox = ({ lightboxAsset, onClose }) => {
  const [assetImagesUrls, setAssetImagesUrls] = useState<any>([])
  const dispatch = useAppDispatch()

  const handleS3Error = error => {
    const errorMsg = error?.data?.error || 'There was an error getting an image'
    trackEvent({ eventName: CHURN_ZERO_EVENTS.GET_S3_IMAGE, errorMsg })
    dispatch(
      setSnackBar({
        snackbarType: 'error',
        snackbarMessage: errorMsg,
      }),
    )
  }

  useEffect(() => {
    // function to fetch signed urls for asset images
    const fetchImageSignedUrls = async (assetImages: string[]) => {
      try {
        const imageUrls = await Promise.all(assetImages.map((assetImage: string) => getImageUrl(assetImage)))
        setAssetImagesUrls(imageUrls)
      } catch (error) {
        handleS3Error(error)
      }
    }

    const assetImages = lightboxAsset?.images || []

    // call function to initiate async call to fetch signed urls
    fetchImageSignedUrls(assetImages)
  }, [lightboxAsset])

  return (
    <>
      <Lightbox
        open={!!lightboxAsset}
        close={() => onClose()}
        slides={assetImagesUrls?.map((url: string) => ({
          src: url || '/logo-vert-light.svg',
        }))}
        plugins={[Thumbnails]}
      />
    </>
  )
}

export default AssetImagesLightbox
